module.exports = __webpack_public_path__ + "static/img/tab2_en.49ca4f14.png";